import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography, notification } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import Loading from "../../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import SelectUsers from "../../../../components/SelectUsers";
import { list as productList } from "../../../../controllers/V1/products/productController";
import { addUpdateBulkInventory } from "../../../../controllers/V1/products/productController"
import { list as pickUpPointList } from "../../../../controllers/V1/cms/pickupPointsDataController";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
const AddBulkInventory = ({ popUpOpen, togglePopUp, type }) => {
  const handleCancel = () => {
    togglePopUp();
    setUserData({});
    setSelectedProduct("");
    setVariantListData([])
    setSelectedVariant("");
  }

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userData, setUserData] = useState([]);
  const [productListData, setProductListData] = useState([]);
  const [variantListDate, setVariantListData] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedVariant, setSelectedVariant] = useState("");
  const [pickupPointList, setPickupPointList] = useState([]);

  const getProductListData = async () => {
    try {
      const options = {
        condition : { status : "A"},
        select : { name : true }
      }
      const res = await productList(options);
      if(res && res?.status === true){
        setProductListData(res?.result || []);
      }
    } catch (error) {
      
    }
  }
  const handleProductChange = (e) => {
    try {
      e.preventDefault();
      const data = JSON.parse(e.target.value);
      setSelectedProduct(data?._id);
      setVariantListData(data?.variants || []);
      if(data?.variants?.length === 1){
        setSelectedVariant(data?.variants[0]?._id)
      }
    } catch (error) {
      
    }
  }

  const getPickUpPointList = async () => {
    try {
      const option = {
        condition : { status : "A" },
        limit : 100,
        sort : { name : -1 }
      }
      const res = await pickUpPointList(option);
      if(res?.status === true){
        setPickupPointList(res?.result);
      }
    } catch (error) {
      
    }
  }

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      let userList = [];
      if(userData?.length > 0){
        userList = userData?.map(item => item?._id);
      }
      if(!selectedProduct || !selectedVariant){
        
      }
      const options = {
        user_id : userList, 
        product_id : selectedProduct, 
        variant_id : selectedVariant, 
        qty : parseInt(formData.get('qty')) || 0, 
        type : type || "Users"
      }
      const res = await addUpdateBulkInventory(options);
      if(res?.status === true){
        notification.open({
          message: "Success",
          description: `Inventory added successfully.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
          duration: 2,
        });
        handleCancel();
      } else{
        notification.open({
          message: "Oops!",
          description: `${res.message}`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      setIsLoading(false);
    } finally{
      setIsLoading(false);
    }
  }

  const handlePickUpChange = async (e) => {
    try {
      const { value } = e.target;
      setUserData([{_id : value}]);
    } catch (error) {
      
    }
  }

  useEffect(()=>{
    getProductListData();
    if(type === "Pick Up Points"){
      getPickUpPointList();
    }
  },[type])

  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography variant="h5" component="div" gutterBottom className="inventory_popup_title_heading mt-3">
            {`Add/Update ${type} inventories stock`}
          </Typography>
          <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>

        <Typography variant="body1" component="div" className="my_delete_popup_paragraph">
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form onSubmit={handleSubmit}>
                <div className="form-group row">
                  {type === "Users" && (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label className="all_lable_for_vendor_dashbaord">Retailers :</label>
                      <SelectUsers user_type="Retailer" setAddEditData={setUserData} mode="multiple" showSelectAll={true}/>
                    </div>
                  )}

                  {type === "Pick Up Points" && (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label htmlFor="code" className="all_lable_for_vendor_dashbaord" onClick={()=>console.log("userData : ", userData)} >Pick-Up Points :</label>
                      <select name="pickUpPoint" id="pickUpPoint" onChange={handlePickUpChange} className="form-control categories_select_tg_enter_product" >
                        <option>Select Pick-Up Points</option>
                        {(pickupPointList && pickupPointList?.length > 0) && (
                          pickupPointList.map((item) => (
                            <option value={item?._id}>{item?.name}</option>
                          ))
                        )}
                      </select>
                    </div>
                  )}

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label htmlFor="product" className="all_lable_for_vendor_dashbaord">Products :</label>
                    <select name="product" id="product" className="form-control categories_select_tg_enter_product" onChange={handleProductChange}>
                      <option>Select Product</option>
                      {(productListData && productListData?.length > 0) && productListData.map((item)=>(
                        <option value={JSON.stringify(item)} selected={item?._id === selectedProduct}>{item?.name?.toUpperCase()}</option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="variant" className="all_lable_for_vendor_dashbaord">Variant :</label>
                    <select name="variant" id="variant" className="form-control categories_select_tg_enter_product">
                      <option>Select Variant</option>
                      {(variantListDate && variantListDate?.length > 0) && variantListDate.map((item)=>(
                        <option value={item?._id} selected={selectedVariant === item?._id} disabled={item?.status !== "A"}>{item?.unit?.toUpperCase()}</option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="variant" className="all_lable_for_vendor_dashbaord">Quantity :</label>
                    <input type="number" name="qty" id="qty" placeholder="Quantity" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel} style={{width : "30%"}}>Cancel</button>
                      <button type="submit" className="btn btn-danger" disabled={isLoading} style={{width : "30%"}}>Submit</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Typography>
        {error && <div style={{ color: 'red' }}>{error}</div>}
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default AddBulkInventory;
